module.exports = __webpack_public_path__ + "60fbaf968c2bbde49ad237389dd830d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tick.svg
// module id = 5
// module chunks = 1